import { DisneyNameMealPLan } from '@core/models/MealPlan/DisneyNameMealPlan.enum';
import { IRate } from '@core/models/Rate/Rate.interface';
import { createAction, props } from '@ngrx/store';
import { StepsEnum } from './actions-selected-plan.reducer';

export enum ActionSelected {
  SHOW_LOADER = '[ActionsTicket] SHOW_LOADER',
  HIDE_LOADER = '[ActionsTicket] HIDE_LOADER',
}

export const changeStep = createAction(
  '[ActionsTicket] changeStep',
  props<{ current_step: StepsEnum }>(),
);

export const ticketAdded = createAction(
  '[ActionsTicket] ticketAdded',
  props<{ ticket_selected: boolean }>(),
);

export const mealPlanByTicket = createAction(
  '[ActionsTicket] mealPlanByTicket',
  props<{ meal_plan: DisneyNameMealPLan[] }>(),
);

export const allowEmptyTicket = createAction(
  '[ActionsTicket] allowEmptyTicket',
  props<{ empty_ticket: boolean }>(),
);

export const selectedRate = createAction(
  '[ActionsTicket] selectedRate',
  props<{ selected_rate: IRate }>(),
);
export const startTicket = createAction(
  '[ActionsTicket] startTicket',
  props<{ start_ticket: string }>(),
);

export const loading = createAction('[ActionsTicket] loading');

export const showLoader = createAction(ActionSelected.SHOW_LOADER);

export const hideLoader = createAction(ActionSelected.HIDE_LOADER);
